import { useFilterSearchParams } from "@/utils/hooksUtils";
import { useState } from "react";
import { FILTER_VEHICLE_FUEL_TYPES_QUERY_PARAMS } from "../api";
import { CertificateFuelType, CertificateFuelTypeFilterPageRequest } from "../types";
import { VehicleFuelTypeFilterForm } from "./forms/VehicleFuelTypeFilterForm";
import { VehicleFuelTypeForm } from "./forms/VehicleFuelTypeForm";
import { VehicleFuelTypeTable } from "./tables/VehicleFuelTypeTable";

export const VehicleFuelTypeTabView = () => {
  const [fuelTypeFormOpen, setFuelTypeFormOpen] = useState<boolean>(false);
  const [fuelTypeToUpdate, setFuelTypeToUpdate] = useState<CertificateFuelType>();

  const searchParams = useFilterSearchParams<CertificateFuelTypeFilterPageRequest>({
    params: ["fuelTypes", "fuelNameSources"],
    defaultQueryParamsObject: FILTER_VEHICLE_FUEL_TYPES_QUERY_PARAMS,
  });

  const handleCreateClick = () => {
    setFuelTypeFormOpen(true);
  };

  const handleUpdateClick = (category: CertificateFuelType) => {
    setFuelTypeFormOpen(true);
    setFuelTypeToUpdate(category);
  };

  const handleFormCancel = () => {
    setFuelTypeFormOpen(false);
    setFuelTypeToUpdate(undefined);
  };

  return (
    <div>
      <VehicleFuelTypeFilterForm searchParams={searchParams} onCreateClick={handleCreateClick} />

      <VehicleFuelTypeTable searchParams={searchParams} onUpdateClick={handleUpdateClick} />

      <VehicleFuelTypeForm fuelType={fuelTypeToUpdate} open={fuelTypeFormOpen} onFormCancel={handleFormCancel} />
    </div>
  );
};
